<template>
        <div class="container">
            <Head v-if="meta.title" v-bind:meta="meta"></Head>
            <Header></Header>
            <Navigation></Navigation>
            <IndexContent></IndexContent>
            <IndexFooter></IndexFooter>
        </div>
</template>

<script>
import Vivus from 'vivus'
import axios from 'axios'

// components

import Head from '@/components/Common/Head.vue'
import Header from '@/components/Header/Header.vue'
import IndexContent from '@/components/Index/IndexContent.vue'
import Navigation from '@/components/Common/Navigation.vue'
import IndexFooter from '@/components/Footer/IndexFooter.vue'


// function

export default {
    name: 'Index',
    components: {
        Head,
        Header,
        Navigation,
        IndexContent,
        IndexFooter
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            photos_description: String,
            documents_description: String,
            biograms_description: String,
            showpieces_description: String,
            biograms_count: Number,
            documents_count: Number,
            photos_count: Number,
            showpieces_count: Number,
            recordings_count: Number,
            slogan: {
                uri: null,
                content: null,
            },
            meta: {
                url: window.location.href,
                description: '',
                title: "",
                og_type: 'website',
                og_image: ''
            },
            key: 0
        }
    },
    methods: {
        cleanView: function() {
            //$(".front-page").empty();
            this.key += 1;
            //this.$forceUpdate();
            //this.fetchData();
    },
        fetchData: function() {
            axios.get(this.$config.API_PATH + 'site')
                .then((_resp) => {
                    let _site = _resp.data

                    if (typeof _site.slogan_uri !== "undefined" && _site.slogan_content !== "undefined") {
                        this.slogan.uri = _site.slogan_uri;
                        this.slogan.content = _site.slogan_content;
                    }
                    
                    this.photos_description = _site.photos_description
                    this.documents_description = _site.documents_description
                    this.biograms_description = _site.biograms_description
                    this.showpieces_description = _site.showpieces_description
                    this.recordings_description = _site.recordings_description


                    this.biograms_count = _site.biograms_count
                    this.photos_count = _site.photos_count
                    this.documents_count = _site.documents_count
                    this.showpieces_count = _site.showpieces_count
                    this.recordings_count = _site.recordings_count


                    // head metadata

                    this.meta.description = _site.description
                    this.meta.title = _site.title
                    this.meta.og_image = require("@/assets/img/default.jpg")
                })
        }
    },
    created() {
        this.fetchData()
        this.setCookie()
        // tify fix
        window.history.replaceState(null, null, window.location.pathname)
    },
    mounted() {
        if(!this.getCookie('animated-fp')) {
            this.toggleBodyId('addId', 'animate')
        } else {
            this.toggleBodyId('removeId', 'animate')
        }
        window.addEventListener("resize", this.cleanView);
        
    },
    updated() {
    },
    head: {
        title: {
            inner: 'Strona główna',
            separator: '|',
            complement: 'Fizykoteka - wirtualne muzeum wydziału fizyki UW'
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Index/Index.vue